import * as Yup from 'yup';

export class UpdateOperationTypeValidator {
  public get schema() {
    return Yup.object().shape({
      blockedAt: Yup.string()
        .nullable()
        .transform((value) => {
          if (value === '1') return new Date().toISOString();
          return null;
        }),
    });
  }
}
